export interface RegionType {
  code: string;
  name: string;
}

export const RegionTypesKey = 'region-types';
